import NProgress from 'nprogress'


import {
    START,
    ERROR,
    FINISH,
} from '../redux/root'

let counter = 0;

const loaderMiddleware = store => next => action => {
  if (action.type === START) {
    NProgress.start()
    counter++
  } else if (action.type === FINISH || action.type === ERROR) {
    counter--
    if (counter < 0) counter = 0
  }
  if (counter === 0) {
    NProgress.done()
  }
  return next(action)
}

export default loaderMiddleware
